import type { DifferentProps } from '@/components/claims/Different';
import type { HeroProps } from '@/components/claims/Hero';
import type { HowItWorksProps } from '@/components/claims/HowItWorks';
import type { StatsProps } from '@/components/claims/Stats';
import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';
import { config as enUsConfig } from '../us/en';

export interface Config extends BasePageConfig {
  hero: HeroProps;
  stats: StatsProps;
  howItWorks: HowItWorksProps;
  different: DifferentProps;
}

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    ...enUsConfig.seo,
    title: 'Hoe de Technisch Aangedreven Claims van Lemonade Werken | Lemonade',
    metaTitle: 'Hoe de Technisch Aangedreven Claims van Lemonade Werken | Lemonade',
    description:
      'Lemonade behandelt claims razendsnel. Dien claims in via de Lemonade-app en je claim wordt direct verwerkt door onze AI bot of door iemand van Lemonade’s claimteam.',
  },
  hero: {
    title: "Het geheim achter Lemonade's claims",
    subtitle:
      'Claims worden behandeld door onze AI bot en ons toegewijde team. Dien razendsnel en probleemloos een claim in met de Lemonade app.',
  },
  stats: {
    steps: [
      {
        ...enUsConfig.stats.steps[0],
        subtitle: 'onze snelste geregistreerde claim',
      },
      {
        ...enUsConfig.stats.steps[1],
        subtitle: 'positieve beoordeling op onze app',
      },
      {
        ...enUsConfig.stats.steps[2],
        subtitle: 'van de claims worden direct afgehandeld',
      },
    ],
  },
  howItWorks: {
    title: 'Hoe Lemonade claims werken',
    subtitle: 'Dien eenvoudig je claim in via je smartphone - waar en wanneer je maar wilt',
    darkBackground: true,
    steps: {
      ...enUsConfig.howItWorks.steps,
      claim_button: {
        ...enUsConfig.howItWorks.steps.claim_button,
        content: `Druk op '<b>Claim Indienen</b>' in de Lemonade app`,
      },
      what_happened: {
        ...enUsConfig.howItWorks.steps.what_happened,
        content: 'Laat ons weten wat er gebeurd is',
      },
      anti_fraud: {
        ...enUsConfig.howItWorks.steps.anti_fraud,
        content: 'Onze AI bot voert al onze anti-fraude algoritmes uit',
      },
      instantly_approved: {
        ...enUsConfig.howItWorks.steps.instantly_approved,
        content:
          'Als je claim <b>direct</b> wordt goedgekeurd, betaalt onze AI bot je het schadebedrag binnen enkele seconden uit',
      },
      humans: {
        ...enUsConfig.howItWorks.steps.humans,
        content:
          'Vergt je claim net iets meer aandacht? Dan staat ons <b>claims team</b> klaar om de schade zo snel mogelijk in behandeling te nemen',
      },
    },
  },
  different: {
    title: 'Claims betalen.\nBijdragen aan een mooiere samenleving.',
    subtitle: `In tegenstelling tot andere verzekeringsmaatschappijen, nemen we een vast percentage van jouw premie, gebruiken we de rest om claims te betalen en <a aria-labelledby="different-subtitle" href="/nl/giveback">doneren</a> we wat overblijft aan goede doelen waar jij om geeft. Dit betekent dat we geen voordeel behalen door het uitstellen of weigeren van claims en daarom behandelen we ze <a aria-labelledby="different-subtitle" href="/nl/faq#claims">snel en eerlijk</a>.`,
    cta: {
      label: 'Bekijk onze prijzen',
    },
  },
};
